import React from 'react';
import styles from './styles.module.scss';

const FormSection = ({ 
  title, 
  children, 
  className = '',
  description = '',
  isCollapsible = false,
  isInitiallyCollapsed = false 
}) => {
  const [isCollapsed, setIsCollapsed] = React.useState(isInitiallyCollapsed);

  const toggleCollapse = () => {
    if (isCollapsible) {
      setIsCollapsed(!isCollapsed);
    }
  };

  return (
    <div className={`${styles.formSection} ${className}`}>
      {(title || isCollapsible) && (
        <div 
          className={`${styles.header} ${isCollapsible ? styles.collapsible : ''}`}
          onClick={toggleCollapse}
        >
          {title && (
            <h3 className={styles.title}>
              {title}
            </h3>
          )}
          {isCollapsible && (
            <span className={styles.collapseIcon}>
              {isCollapsed ? '▶' : '▼'}
            </span>
          )}
        </div>
      )}
      
      {description && !isCollapsed && (
        <p className={styles.description}>
          {description}
        </p>
      )}
      
      {!isCollapsed && (
        <div className={styles.content}>
          {children}
        </div>
      )}
    </div>
  );
};

export default FormSection;